export default class PostePrevisionnelDto {
  id;
  codeRome;
  nbRecrutement;
  typesContrat = [];
  formation;
  trimestre;
  ouvertureInsertion;
  isTouched;
}
